var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActuatorChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2067_22562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#384663"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2067_22562)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#2E3A54"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 5.46436,
    x2: 40,
    y2: 5.46436,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 11.1787,
    x2: 40,
    y2: 11.1787,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 16.8931,
    x2: 40,
    y2: 16.8931,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 22.6072,
    x2: 40,
    y2: 22.6072,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 28.3213,
    x2: 40,
    y2: 28.3213,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 34.0356,
    x2: 40,
    y2: 34.0356,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 39.75,
    x2: 40,
    y2: 39.75,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35 12H-28.8054H-19.9254V28H-11.0455V12H-2.16555V28H6.71439V12H15.5943V28H24.4743V12H33.3542V28H42.2342V12H56",
    stroke: "#C26277"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActuatorChart);
export default __webpack_public_path__ + "static/media/actuator-chart.01c3d283.svg";
export { ForwardRef as ReactComponent };